export default __webpack_public_path__ + "static/media/kwait.1d631032.svg";